var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMembershipExpired === true)?_c('v-icon',{staticClass:"warning--icon",on:{"click":_vm.openWarning}},[_vm._v("mdi-alert")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }